import HttpApi from '@/utils/HttpApi'
import { ImageInterface } from '@/utils/image'

interface IntegrationModule {
    module: IntegrationModuleEntity
}

interface SingleIntegrationModuleEntity {
    module?: IntegrationModuleEntity
    categories: ModulecategoryEntity[]
    partners: ModulepartnerEntity[]
}

export default class IntegrationsApi {
    public static async getIntegrations(params: any) {
        return await HttpApi.get<IntegrationModulesEntity>('integration', params)
    }

    public static async getIntegration(id: number) {
        return await HttpApi.get<SingleIntegrationModuleEntity>(`integration/${id}`, null)
    }

    public static async putIntegration(data: IntegrationModuleEntity) {
        return await HttpApi.put<IntegrationModule>('integration', data)
    }

    public static async postIntegration(data: IntegrationModuleEntity) {
        return await HttpApi.post<IntegrationModule>('integration', data)
    }

    public static async updateIntegration(params: any) {
        return await HttpApi.put<IntegrationModule>(`integration/update`, params)
    }

    public static async deleteIntegration(id: number) {
        return await HttpApi.delete<any>(`integration/${id}`, null, undefined, false)
    }

    public static async orderIntegrations(params: any) {
        return await HttpApi.put<any>('integration/order', params)
    }

    public static async uploadIntegrationLogo(id: number, logo: ImageInterface) {
        const formData = new FormData()

        formData.append('id', (id as any))

        if (logo.file !== undefined) {
            formData.append('logo', logo.file)
        }

        return await HttpApi.upload<any>('integration/upload', formData)
    }
}
